// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {get} from 'lodash';

// Relative Imports
import helpActions from '../../actions/help';
import appActions from '../../actions/actions';
import IneligibleHelpForm from './IneligibleHelpForm';
import HelpForm from './HelpForm';

function mapStateToProps(state) {
    return {
        state,
        translations: state.app.translations,
        environment: state.system.environment,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        recaptchaResp: get(state, 'app.helpRecaptchaResp', ''),
        publicUuid: get(state, 'app.publicUuid', '-1'),
        isHelpModalOpen: get(state, 'help.isHelpModalOpen', false),
        isInEligibleModalOpen: get(state, 'help.isInEligibleModalOpen', false),
        isUnlistedSoftware: get(state, 'help.isUnlistedSoftware', false),
        isIneligibleStatus: get(state, 'app.ineligibilityFormStatus', ''),
        emailVal: get(state, 'help.emailVal', ''),
        emailError: get(state, 'help.emailError', ''),
        firstNameVal: get(state, 'help.firstNameVal', ''),
        firstNameError: get(state, 'help.firstNameError', ''),
        lastNameVal: get(state, 'help.lastNameVal', ''),
        lastNameError: get(state, 'help.lastNameError', ''),
        phoneNumberVal: get(state, 'help.phoneNumberVal', ''),
        phoneNumberError: get(state, 'help.phoneNumberError', ''),
        propertyCountVal: get(state, 'help.propertyCountVal', ''),
        propertyCountError: get(state, 'help.propertyCountError', ''),
        softwareNameVal: get(state, 'help.softwareNameVal', ''),
        softwareNameError: get(state, 'help.softwareNameError', ''),
        companyNameVal: get(state, 'help.companyNameVal', ''),
        companyNameError: get(state, 'help.companyNameError', ''),
        helpSubVal: get(state, 'help.helpSubVal', ''),
        helpSubError: get(state, 'help.helpSubError', ''),
        helpMessageVal: get(state, 'help.helpMessageVal', ''),
        helpMessageError: get(state, 'help.helpMessageError', ''),
        businessType: get(state, 'help.businessType', ''),
        vatNumberChoice: get(state, 'help.vatChoice', ''),
        companyCountryCode: get(state, 'help.companyCountryCode', ''),
        companyCountry: get(state, 'help.countryName', ''),
        serviceError: get(state, 'help.serviceError', ''),
        serviceSuccess: get(state, 'help.serviceSuccess', ''),
        brandName: state.system.brandName
    };
}

function mapDispatchToProps(dispatch) {
    return {
        helpActions: bindActionCreators(helpActions, dispatch),
        appActions: bindActionCreators(appActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class HelpContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleFieldValOnChange = this.handleFieldValOnChange.bind(this);
        this.handleFieldValOnBlur = this.handleFieldValOnBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.scrollModalToTop = this.scrollModalToTop.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
        this.setRecaptchaRef = this.setRecaptchaRef.bind(this);
    }

    componentDidMount() {
        window.recaptchaOptions = {
            lang: this.props.preferredLocale
        };
    }

    componentWillReceiveProps(nextProps) {
        this.prepopulateIneligibleValues(nextProps);
        this.onHelpModalPropChange(nextProps);
        this.onRecaptchaRespChange(nextProps);
    }

    prepopulateIneligibleValues(nextProps) {
        if (!this.props.isInEligibleModalOpen && nextProps.isInEligibleModalOpen) {
            this.props.helpActions.prepopulateIneligibleValues(this.props.state);
        }
    }

    onHelpModalPropChange(nextProps) {
        let {isHelpModalOpen, publicUuid} = this.props;

        if (!isHelpModalOpen && nextProps.isHelpModalOpen) {
            this.props.appActions.triggerEdapPageView(publicUuid, 'Help Page');
            this.props.appActions.setCaptchaResponse('help', '');
        }
    }

    onRecaptchaRespChange(nextProps) {
        if (!this.props.recaptchaResp && nextProps.recaptchaResp) {
            this.submitHelpForm(nextProps.recaptchaResp);
        }
    }

    onCaptchaChange(response) {
        this.props.appActions.setCaptchaResponse('help', response);
    }

    handleClose = () => {
        this.props.helpActions.toggleHelpModal(false);
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Help Close'
        }, {});
    };

    handleFieldValOnChange = (event) => {
        this.props.helpActions.handleFieldValOnChange(event.target.id, event.target.value);
    };

    handleFieldValOnBlur = (event) => {
        this.props.helpActions.handleFieldValOnBlur(event.target.id, event.target.value);
    };

    handleSubmit() {
        let {serviceError, serviceSuccess} = this.props;

        if (serviceError || serviceSuccess) {
            this.handleAlertDismiss();
        }

        if (this.isFormValid()) {
            this.recaptchaRef.execute();
        } else {
            this.props.helpActions.showFieldError();
        }
    }

    submitHelpForm(recaptchaResp) {
        let {firstNameVal, lastNameVal, emailVal, companyNameVal, companyCountry, vatNumberChoice,
            propertyCountVal, softwareNameVal, isUnlistedSoftware, businessType, phoneNumberVal, helpSubVal, helpMessageVal, translations} = this.props;

        const helpFormData = {
            data: {
                firstName: firstNameVal,
                lastName: lastNameVal,
                emailAddress: emailVal,
                companyName: companyNameVal,
                companyLocation: companyCountry,
                vatStatus: vatNumberChoice,
                propertyCount: propertyCountVal,
                propertyManagementSoftware: softwareNameVal,
                isUnlistedSoftware,
                businessUnit: businessType,
                subject: (helpSubVal) ? helpSubVal : 'SSO Help Request',
                message: helpMessageVal,
                phoneNumber: phoneNumberVal,
                translations
            },
            recaptchaResp
        };
        this.props.helpActions.submitHelpForm(helpFormData);
        this.props.appActions.enableLoadOverLay(true);
        this.props.appActions.triggerEdapEvent('generic.click', {eventcategory: 'Help Submit'}, {});
        this.props.appActions.setCaptchaResponse('help', '');
        this.recaptchaRef.reset();
    }

    isFormValid() {
        return this.props.emailVal && this.props.firstNameVal && this.props.lastNameVal
            && this.props.phoneNumberVal && this.props.helpSubVal && this.props.helpMessageVal
            && !this.props.emailError
            && (this.props.isUnlistedSoftware ? this.props.propertyCountVal && this.props.softwareNameVal && this.props.companyNameVal: true)
    }

    handleAlertDismiss() {
        this.props.helpActions.alertSuccess('');
        this.props.helpActions.alertError('');
    }

    scrollModalToTop() {
        const elements = document.getElementsByClassName('Modal');
        if (elements.length > 0 && elements[0]) {
            let modalElem = elements[0];

            // Check element has no scroll property
            if (modalElem.scrollHeight <= modalElem.clientHeight) {
                modalElem = document.getElementsByClassName('Modal__body')[0];
            }

            modalElem.scrollTop = 0;
        }
    }

    setRecaptchaRef = (ref) => {
        this.recaptchaRef = ref;
    }

    render() {
        const scrollTop = (this.props.serviceError || this.props.serviceSuccess) ? true : false;

        return (
            (this.props.isInEligibleModalOpen) ?
                (<div id="inEligibleHelpForm" className="ineligible-help-form">
                    <IneligibleHelpForm {...this.props}
                        handleClose={this.handleClose}
                        scrollTop={scrollTop}
                        scrollModalToTop={this.scrollModalToTop}
                        handleFieldValOnChange={this.handleFieldValOnChange}
                        handleFieldValOnBlur={this.handleFieldValOnBlur}
                        appActions={this.props.appActions}
                        handleSubmit={this.handleSubmit}
                        onCaptchaChange={this.onCaptchaChange}
                        setRecaptchaRef={this.setRecaptchaRef}
                        environment={this.props.environment}
                    />
                </div>) :
                (<div id="helpForm" className="help-form">
                    <HelpForm
                        {...this.props}
                        handleClose={this.handleClose}
                        scrollTop={scrollTop}
                        scrollModalToTop={this.scrollModalToTop}
                        handleAlertDismiss={this.handleAlertDismiss}
                        handleFieldValOnChange={this.handleFieldValOnChange}
                        handleFieldValOnBlur={this.handleFieldValOnBlur}
                        onCaptchaChange={this.onCaptchaChange}
                        handleSubmit={this.handleSubmit}
                        setRecaptchaRef={this.setRecaptchaRef}
                        environment={this.props.environment}
                    />
                </div>)
        );
    }
}

export default HelpContainer;
